import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-set-parameter',
  templateUrl: './set-parameter.component.html'
})
export class SetParameterComponent implements OnInit {

  // Property Declaration
  setparameterForm: FormGroup;
  RoleName: string = '';
  DisplayButton: boolean = false;
  SiteMasterList: any;
  IsreadOnly: boolean = false;
  IsreadOnly1: boolean = false;
  UnitRate: string = '';
  PowerFactorPenalty: string = '';

  constructor(private form: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<SetParameterComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    if (data && data.SiteMasterList) {
      this.SiteMasterList = data.SiteMasterList;
    }
  }

  ngOnInit(): void {

    this.RoleName = localStorage.getItem('RoleName');

    this.setparameterForm = this.form.group({
      UnitRate: [''],
      PowerFactorPenalty: [''],
      ThresholdEnergy: [''],
      ThresholdTemperature: [''],
      ThresholdHumidity: [''],
      ThresholdMDI: [''],
      ThresholdPowerFactor: [''],
      ThresholdElectricityBill: [''],
      AnalogTemprature: [''],
      AnalogHumidity: ['']
    });

    if (this.RoleName == 'PortalAdmin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
      this.IsreadOnly1 = true;
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
      this.IsreadOnly1 = false;
    }

    this.SetSiteDetails();
  }

  // Set Parameter Values
  SetSiteDetails() {

    this.setparameterForm.patchValue({
      UnitRate: this.SiteMasterList.UnitRate,
      PowerFactorPenalty: this.SiteMasterList.PowerFactorPenalty,
      ThresholdEnergy: this.SiteMasterList.ThresholdEnergy,
      ThresholdTemperature: this.SiteMasterList.ThresholdTemperature,
      ThresholdHumidity: this.SiteMasterList.ThresholdHumidity,
      ThresholdMDI: this.SiteMasterList.ThresholdMDI,
      ThresholdPowerFactor: this.SiteMasterList.ThresholdPowerFactor,
      ThresholdElectricityBill: this.SiteMasterList.ThresholdElectricityBill,
      AnalogTemprature: this.SiteMasterList.AnalogTemprature,
      AnalogHumidity: this.SiteMasterList.AnalogHumidity
    });
  }

  // Call on click Save button
  OnSubmit(): void {
    this.UnitRate = '';
    this.PowerFactorPenalty = '';
    var Setparamvalue = { ...this.setparameterForm.value };

    if (Setparamvalue.UnitRate == 0) {
      this.UnitRate = 'Unit Rate is required';
    }
    if (Setparamvalue.PowerFactorPenalty == 0) {
      this.PowerFactorPenalty = 'Power Factor Penalty is required';
    }

    if (this.UnitRate != '' || this.PowerFactorPenalty !== '') {
      return;
    }

    var ReqObj = {
      UnitRate: Setparamvalue.UnitRate,
      PowerFactorPenalty: Setparamvalue.PowerFactorPenalty,
      ThresholdEnergy: Setparamvalue.ThresholdEnergy,
      ThresholdTemperature: Setparamvalue.ThresholdTemperature,
      ThresholdHumidity: Setparamvalue.ThresholdHumidity,
      ThresholdMDI: Setparamvalue.ThresholdMDI,
      ThresholdPowerFactor: Setparamvalue.ThresholdPowerFactor,
      ThresholdElectricityBill: Setparamvalue.ThresholdElectricityBill,
      AnalogTemprature: Setparamvalue.AnalogTemprature,
      AnalogHumidity: Setparamvalue.AnalogHumidity
    };
    this.dialogRef.close(ReqObj);
  }

  // Call on click Cancel button
  OnCancel() {
    var ReqObj = {
      UnitRate: 0,
      PowerFactorPenalty: 0,
      ThresholdEnergy: 0,
      ThresholdTemperature: 0,
      ThresholdHumidity: 0,
      ThresholdMDI: 0,
      ThresholdPowerFactor: 0,
      ThresholdElectricityBill: 0,
      AnalogTemprature: 0,
      AnalogHumidity: 0
    };
    this.dialogRef.close(ReqObj);
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }
}
